import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CHECKOUT_SUCCESS_URL, CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    FooterContainer as SourceFooterContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/Footer/Footer.container';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { CustomerType } from 'Type/Account.type';
import history from 'Util/History';

/** @namespace PeggysagePwa/Component/Footer/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    navigationState: state.NavigationReducer[TOP_NAVIGATION_TYPE].navigationState,
    customer: state.MyAccountReducer.customer
});

/** @namespace PeggysagePwa/Component/Footer/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch)
});

/** @namespace PeggysagePwa/Component/Footer/Container */
export class FooterContainer extends SourceFooterContainer {
    static propTypes = {
        ...SourceFooterContainer.propTypes,
        customer: CustomerType.isRequired,
        isEmbed: PropTypes.bool
    };

    static defaultProps = {
        ...SourceFooterContainer.defaultProps,
        isVisibleOnMobile: true,
        isEmbed: false
    };

    state = {
        isCheckout: false,
        userGroupId: 0
    };

    componentDidMount() {
        this.checkLocation();
        this.getCustomerGroup();
    }

    componentDidUpdate(prevProps) {
        const {
            navigationState: { name: prevName },
            customer: { group_id: prevGroupId = 0 } = {}
        } = prevProps;
        const {
            navigationState: { name },
            customer: { group_id: groupId = 0 } = {}
        } = this.props;

        if (prevName !== name) {
            this.checkLocation();
        }

        if (groupId !== prevGroupId) {
            this.getCustomerGroup();
        }
    }

    checkLocation() {
        const { location: { pathname } } = history;

        this.setState({
            isCheckout: pathname.includes(CHECKOUT_URL) && !pathname.includes(CHECKOUT_SUCCESS_URL)
        });
    }

    getCustomerGroup() {
        const { customer: { group_id: groupId = 0 } = {} } = this.props;

        this.setState({ userGroupId: groupId });
    }

    /**
     * Override
     */
    containerProps() {
        const { isEmbed } = this.props;
        const { isCheckout, userGroupId } = this.state;

        return {
            ...super.containerProps(),
            isEmbed,
            isCheckout,
            userGroupId
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);
